<template>
  <form v-if="formSearch">
    <md-card-content>
      <div class="md-layout">
        <div
          class="md-layout-item md-size-25 md-large-size-20 md-xsmall-size-50"
          v-for="item in formSearch"
          :key="item.name"
        >
          <!--  Datepicker -->
          <md-datepicker
            v-if="item.type === 'date'"
            v-model="item.value"
            md-immediately
          >
            <label>{{ item.label }}</label>
          </md-datepicker>

          <!--  Select -->
          <md-field v-else-if="item.type === 'select'">
            <label :for="item.name">{{ item.label }}</label>
            <md-select
              v-model="item.value"
              :name="item.name"
              :id="item.name"
              @change="search"
            >
              <md-option :value="''">{{ $t("common.all") }}</md-option>
              <md-option
                :value="option.id"
                v-for="option in item.options"
                :key="option.id"
                >{{ option.name }}
              </md-option>
            </md-select>
          </md-field>

          <!--  Autocomplete -->
          <md-autocomplete
            v-else-if="item.type === 'autocomplete'"
            v-model="item.value"
            :md-options="autoOptions"
            @md-changed="getOptions"
            @md-opened="getOptions"
            :auto-path="genAutoPath(item.path)"
          >
            <label>{{ item.label }}</label>
            <template slot="md-autocomplete-item" slot-scope="{ item, term }">
              <md-highlight-text :md-term="term"
                >{{ item }} {{ term }}
              </md-highlight-text>
            </template>
            <template slot="md-autocomplete-empty" slot-scope="{ term }">
              "{{ term }}" not found!
            </template>
            <div class="md-helper-text" v-if="item.value">
              <strong>Item:</strong>{{ item.name }} ({{ item.value }})
            </div>
          </md-autocomplete>

          <!--  Select2 -->
          <md-field v-else-if="item.type === 'select2'">
            <label :for="item.name" class="select-label">{{
              item.label
            }}</label>
            <div class="form-select2-container">
              <select2
                v-model="item.value"
                :id="'select2-selection-' + item.name"
                :name="item.name"
                :disabled="item.disabled"
                :options="item.options"
                @change="search"
                :settings="{ dropdownAutoWidth: true, width: 'inherit' }"
              />
            </div>
          </md-field>

          <!--  Input -->
          <md-field v-else>
            <label>{{ item.label }}</label>
            <md-input
              v-model="item.value"
              :data-vv-name="item.name"
              :type="item.type"
              @keydown.enter="search"
            >
            </md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-25 md-large-size-20 md-xsmall-size-100"
        >
          <md-button
            native-type="submit"
            @click.native.prevent="search"
            class="md-success"
            >{{ $t("common.search") }}
          </md-button>
        </div>
      </div>
    </md-card-content>
    <md-card-actions class="text-center">
      <md-button
        @click.native.prevent="exportExcel"
        class="md-info"
        v-if="enableExport"
        >{{ $t("common.export_excel") }}
      </md-button>
    </md-card-actions>
  </form>
</template>

<script>
import queryHelper from "@/helpers/query-helper";
import _ from "lodash";
import { Http } from "../../services/http.init";

export default {
  name: "BaseSearchForm",
  components: {},
  props: ["formSearch", "enableExport"],
  data() {
    return {
      autoOptions: [],
      autoPath: "/"
    };
  },
  methods: {
    search() {
      let params = queryHelper.buildQuery(this.formSearch);
      this.$emit("search", params);
    },
    exportExcel() {
      let params = queryHelper.buildQuery(this.formSearch);
      this.$emit("exportExcel", params);
    },
    fetchOptions: _.debounce(async function(term) {
      let form = [
        {
          name: "name__~",
          value: term
        }
      ];
      new Http({ auth: true })
        .get(this.autoPath, { yql: queryHelper.buildQuery(form) })
        .then(response => {
          let options = [];
          response.data.data.forEach(value => {
            options.push(value.name);
          });
          this.autoOptions = options;
        });
    }, 500),
    getOptions(term) {
      this.fetchOptions(term);
    },
    genAutoPath: function(path) {
      this.autoPath = path;
    }
  },
  computed: {}
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
